import { KeyboardEvent, forwardRef, FocusEvent, ChangeEvent, MouseEvent } from 'react'

import { tw } from '~/lib/utils'

export type InputPropsType = {
  className?: string
  placeholder?: string
  type?: string
  value: string | number | null
  minLength?: number
  maxLength?: number
  onChange: (value: ChangeEvent<HTMLInputElement>) => void
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void
  onClick?: (event: MouseEvent<HTMLInputElement>) => void
  disabled?: boolean
  autoFocus?: boolean
  id?: string
}

const Input = forwardRef<HTMLInputElement, InputPropsType>(
  (
    {
      className,
      placeholder,
      type = 'text',
      value,
      minLength,
      maxLength,
      onChange,
      onFocus,
      onBlur,
      onKeyDown,
      onPaste,
      onClick,
      disabled,
      autoFocus,
      id,
    },
    ref
  ) => {
    return (
      <input
        autoComplete="off"
        autoFocus={autoFocus}
        className={tw(
          'h-10 w-full rounded border border-solid border-input px-2 py-1 text-body-m text-default focus:border-transparent focus:outline-none focus:ring-[1.5px] focus:ring-blue-600',
          className
        )}
        data-1p-ignore
        disabled={disabled}
        id={id}
        maxLength={maxLength}
        minLength={minLength}
        placeholder={placeholder}
        ref={ref}
        type={type}
        value={!value && value !== 0 ? '' : value}
        onBlur={onBlur}
        onChange={onChange}
        onClick={onClick}
        onFocus={onFocus}
        onKeyDown={(event) => {
          if (event.key === 'Escape') event.currentTarget.blur()

          onKeyDown?.(event)
        }}
        onPaste={onPaste}
      />
    )
  }
)

Input.displayName = 'Input'
export default Input
